import {
  Alert,
  AlertTitle,
  Box,
} from "@mui/material";

import { useCurrentOrg } from "~/providers/GraphqlProvider";
import { useHasPermission, Permission } from "~/hooks/permissions";
import { permissionDescriptions } from "@caredna-marlin/utils/userRoles";

type Props = {
  permission: Permission,
  children?: React.ReactNode,
}

export default function PermissionOrWarn({ permission, children = null }: Props) {
  const hasPermission = useHasPermission(permission);
  const orgName = useCurrentOrg()?.name || "this organization";

  if (hasPermission) {
    return children;
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minWidth="100%">
      <Alert severity="warning" sx={{maxWidth: 360, margin: "5em"}}>
        <AlertTitle>Access denied</AlertTitle>
        You do not have permission to {permissionDescriptions[permission]} in the Medarrive web app for {orgName}. If you believe this message is in error, contact your administrator.
      </Alert>
    </Box>
  )
}
